import React, { useCallback, useMemo, useState } from 'react';
import { Divider, Radio } from 'antd';
import { useTranslation } from 'react-i18next';
import BackToListing from '@components/BackToListing';
import useSearchParams from '@hooks/useSearchParams';
import CustomTag from '@components/CustomTag';
import ConsolidatedInvoice from './Consolidated';
import DetailedInvoice from './Detailed';

const InvoiceDetailed = () => {
  const { t } = useTranslation(['invoices', 'customers', 'requests']);
  const [invoiceStatus, setInvoiceStatus] = useState<boolean>();

  const { setSearchParams, searchParams } = useSearchParams({
    defaultParams: ['type', 'itemsType', 'selectedSubInvoice'],
  });

  const { type } = useMemo(() => searchParams, [searchParams]);

  const isConsolidated = useMemo(
    () => !type || type === 'consolidated',
    [type],
  );

  const handleTabsCardChange = useCallback(
    (tabType: string) => {
      setSearchParams({ type: tabType });
    },
    [setSearchParams],
  );

  return (
    <div>
      <BackToListing
        title={
          <>
            {t('cards.details')}
            {invoiceStatus !== undefined && (
              <CustomTag
                color={invoiceStatus ? 'green' : 'red'}
                style={{ marginLeft: 16 }}
              >
                {(invoiceStatus
                  ? t('searchResultItem.opened')
                  : t('searchResultItem.closed')
                ).toUpperCase()}
              </CustomTag>
            )}
          </>
        }
      />

      <Divider style={{ marginBottom: 16 }}>
        <Radio.Group
          value={type}
          defaultValue="consolidated"
          onChange={({ target: { value } }) => handleTabsCardChange(value)}
        >
          <Radio.Button value="consolidated">
            {t('invoice.tabs.consolidated')}
          </Radio.Button>
          <Radio.Button value="detailed">
            {t('invoice.tabs.detailed')}
          </Radio.Button>
        </Radio.Group>
      </Divider>

      {isConsolidated ? (
        <ConsolidatedInvoice
          searchParams={searchParams}
          setSearchParams={setSearchParams}
          setInvoiceStatus={setInvoiceStatus}
        />
      ) : (
        <DetailedInvoice
          searchParams={searchParams}
          setSearchParams={setSearchParams}
        />
      )}
    </div>
  );
};

export default InvoiceDetailed;
